var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "svg-icon",
      class: _vm.iconClass,
      style: {
        color: _vm.iconColor,
        width: _vm.iconWidth ? _vm.iconWidth + "px" : null,
        height: _vm.iconHeight ? _vm.iconHeight + "px" : null,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.name === "arrow-left"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "10",
                viewBox: "0 0 14 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.292893 5.69471C-0.0976311 5.30419 -0.0976311 4.67103 0.292893 4.2805L4.27191 0.301682C4.66243 -0.088842 5.2956 -0.088842 5.68612 0.301682C6.07664 0.692207 6.07664 1.32537 5.68612 1.7159L1.70711 5.69471C1.31658 6.08524 0.683417 6.08524 0.292893 5.69471Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M0.292893 4.30507C-0.0976311 4.69559 -0.0976311 5.32876 0.292893 5.71928L4.27191 9.69831C4.66243 10.0888 5.2956 10.0888 5.68612 9.69831C6.07664 9.30779 6.07664 8.67462 5.68612 8.2841L1.70711 4.30507C1.31658 3.91454 0.683417 3.91454 0.292893 4.30507Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M0.985811 4.98761C0.985811 4.43532 1.43353 3.98761 1.98581 3.98761H12.0015C12.5537 3.98761 13.0015 4.43532 13.0015 4.98761C13.0015 5.53989 12.5537 5.98761 12.0015 5.98761H1.98581C1.43353 5.98761 0.985811 5.53989 0.985811 4.98761Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "arrow-right"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "10",
                viewBox: "0 0 14 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M13.7071 5.69471C14.0976 5.30419 14.0976 4.67103 13.7071 4.2805L9.72809 0.301682C9.33757 -0.088842 8.7044 -0.088842 8.31388 0.301682C7.92336 0.692207 7.92336 1.32537 8.31388 1.7159L12.2929 5.69471C12.6834 6.08524 13.3166 6.08524 13.7071 5.69471Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M13.7071 4.30507C14.0976 4.69559 14.0976 5.32876 13.7071 5.71928L9.72809 9.69831C9.33757 10.0888 8.7044 10.0888 8.31388 9.69831C7.92336 9.30779 7.92336 8.67462 8.31388 8.2841L12.2929 4.30507C12.6834 3.91454 13.3166 3.91454 13.7071 4.30507Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M13.0142 4.98761C13.0142 4.43532 12.5665 3.98761 12.0142 3.98761H1.99854C1.44625 3.98761 0.998535 4.43532 0.998535 4.98761C0.998535 5.53989 1.44625 5.98761 1.99854 5.98761H12.0142C12.5665 5.98761 13.0142 5.53989 13.0142 4.98761Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "arrow-rotate-left"
        ? _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "14",
                viewBox: "0 0 16 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "arrow-2-right"
        ? _c(
            "svg",
            {
              attrs: {
                width: "7",
                height: "12",
                viewBox: "0 0 7 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "bin"
        ? _c(
            "svg",
            {
              attrs: {
                width: "13",
                height: "15",
                viewBox: "0 0 13 15",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z",
                  fill: "#FF238D",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "box-archive"
        ? _c(
            "svg",
            {
              attrs: {
                width: "15",
                height: "14",
                viewBox: "0 0 15 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M6 8H9M1 1H14V5H1V1ZM2 5H13V13H2V5Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "calculator"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "16",
                viewBox: "0 0 14 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M4 5H10M4 8H6M4 11H6M8 8H10M8 11H10M3 15H11C12.1046 15 13 14.1046 13 13V3C13 1.89543 12.1046 1 11 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "calendar"
        ? _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M13 1V5",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M5 1V5",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "4",
                  y: "8",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "4",
                  y: "12",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "8",
                  y: "8",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "8",
                  y: "12",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "12",
                  y: "8",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
              _c("rect", {
                attrs: {
                  x: "12",
                  y: "12",
                  width: "2",
                  height: "2",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "change-tab"
        ? _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "13",
                viewBox: "0 0 16 13",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M3 8C2.44772 8 2 8.44772 2 9C2 9.55229 2.44772 10 3 10V8ZM10 9L10.7007 9.71345C10.8922 9.52542 11 9.26834 11 9C11 8.73166 10.8922 8.47458 10.7007 8.28655L10 9ZM8.15525 5.78655C7.76123 5.39956 7.12809 5.40527 6.7411 5.79929C6.35411 6.19332 6.35981 6.82646 6.75384 7.21345L8.15525 5.78655ZM6.75384 10.7866C6.35981 11.1735 6.35411 11.8067 6.7411 12.2007C7.12809 12.5947 7.76123 12.6004 8.15525 12.2134L6.75384 10.7866ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM6 1H7C7 0.447715 6.55228 0 6 0V1ZM6 4V5C6.55228 5 7 4.55228 7 4H6ZM1 4H0C0 4.55228 0.447715 5 1 5L1 4ZM10 1V0C9.44771 0 9 0.447715 9 1L10 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 4V5C15.5523 5 16 4.55228 16 4H15ZM10 4H9C9 4.55228 9.44771 5 10 5V4ZM3 10H10V8H3V10ZM10.7007 8.28655L8.15525 5.78655L6.75384 7.21345L9.29929 9.71345L10.7007 8.28655ZM9.29929 8.28655L6.75384 10.7866L8.15525 12.2134L10.7007 9.71345L9.29929 8.28655ZM1 2H6V0H1V2ZM5 1V4H7V1H5ZM6 3H1V5H6V3ZM2 4V1H0V4H2ZM10 2H15V0H10V2ZM14 1V4H16V1H14ZM15 3H10V5H15V3ZM11 4V1H9V4H11Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "check"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "10",
                viewBox: "0 0 14 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "chevron-left"
        ? _c(
            "svg",
            {
              attrs: {
                width: "7",
                height: "12",
                viewBox: "0 0 7 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.290951 5.30964C0.678886 4.92189 1.30785 4.92189 1.69579 5.30964L6.69353 10.305C7.08146 10.6928 7.08146 11.3214 6.69353 11.7092C6.30559 12.0969 5.67663 12.0969 5.28869 11.7092L0.290951 6.71381C-0.0969839 6.32606 -0.0969834 5.69739 0.290951 5.30964Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M0.290951 6.70587C0.678886 7.09363 1.30785 7.09363 1.69579 6.70587L6.70905 1.69498C7.09698 1.30723 7.09698 0.678565 6.70905 0.290814C6.32111 -0.0969378 5.69215 -0.0969378 5.30421 0.290814L0.290951 5.3017C-0.0969839 5.68946 -0.0969834 6.31812 0.290951 6.70587Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "chevron-right"
        ? _c(
            "svg",
            {
              attrs: {
                width: "7",
                height: "12",
                viewBox: "0 0 7 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814627 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969379 1.32337 -0.0969379 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31055 7.09698 5.68188 6.70905 5.29413Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "chevron-top-circled"
        ? _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "11",
                  cy: "11",
                  r: "10.5",
                  fill: "white",
                  stroke: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "clip"
        ? _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 13 15",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M11.551 9.4812L8.27747 12.7523C7.478 13.5512 6.39368 14 5.26305 14C4.13242 14 3.04809 13.5512 2.24862 12.7523C1.44914 11.9534 1 10.8699 1 9.74011C1 8.61031 1.44914 7.52679 2.24862 6.72791L7.14835 1.8318C7.68133 1.29921 8.40422 1 9.15797 1C9.91172 1 10.6346 1.29921 11.1676 1.8318C11.7006 2.36439 12 3.08673 12 3.83993C12 4.59312 11.7006 5.31547 11.1676 5.84806L6.26075 10.7442C5.99426 11.0105 5.63282 11.1601 5.25594 11.1601C4.87907 11.1601 4.51763 11.0105 4.25114 10.7442C3.98464 10.4779 3.83493 10.1167 3.83493 9.74011C3.83493 9.36351 3.98464 9.00233 4.25114 8.73604L8.65379 4.34374",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "clock-rotate-left"
        ? _c(
            "svg",
            {
              attrs: {
                width: "17",
                height: "15",
                viewBox: "0 0 17 15",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M9.5 13.8202C12.8137 13.8202 15.5 11.1339 15.5 7.82019C15.5 4.50648 12.8137 1.82019 9.5 1.82019C6.18629 1.82019 3.5 4.50648 3.5 7.82019M9.5 4.82019V7.82019L11.5 8.82019M1.5 7.82019L3.5 9.82019L5.5 7.82019",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "comment"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M11.5 1H2.5C1.67266 1 1 1.68507 1 2.52767V8.47233C1 9.31493 1.67266 10 2.5 10H5.00023V12.7128C5.00023 12.9468 5.26273 13.0828 5.44789 12.9444L9.00047 10H11.5C12.3273 10 13 9.31493 13 8.47233V2.52767C13 1.68507 12.3273 1 11.5 1Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "copy"
        ? _c(
            "svg",
            {
              attrs: {
                width: "17",
                height: "17",
                viewBox: "0 0 17 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M11 4V2C11 1.44772 10.4404 1 9.75 1H2.25C1.55964 1 1 1.44772 1 2V10C1 10.5523 1.55964 11 2.25 11H4M7 16H15C15.5523 16 16 15.5523 16 15V7C16 6.44772 15.5523 6 15 6H7C6.44772 6 6 6.44772 6 7V15C6 15.5523 6.44772 16 7 16Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "eye"
        ? _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 36 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M34 11C34 11 26.8366 21 18 21C9.16344 21 2 11 2 11C2 11 9.16344 1 18 1C26.8366 1 34 11 34 11Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M24 9C24 12.3137 21.3137 15 18 15C14.6863 15 12 12.3137 12 9C12 5.68629 14.6863 3 18 3C21.3137 3 24 5.68629 24 9Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "file"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 14 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  stroke: "currentColor",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12.96 6.5v8h-11v-13h6m5 5h-5v-5m5 5-5-5",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "new-line"
        ? _c(
            "svg",
            {
              attrs: {
                width: "11",
                height: "11",
                viewBox: "0 0 11 11",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 7.00073L4 4.00073M1 7.00073L4 10.0007M1 7.00073H10V1.00073",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "pdf"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 13V1H13V13H1Z",
                  stroke: "#E30000",
                  "stroke-width": "2",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M7.97945 6.09586C7.48199 6.49417 7.46615 6.50383 7.17242 6.75471C6.87868 7.00559 6.76904 7.04139 6.26922 7.43694M7.97945 6.09586C9.67803 5.44281 10.1319 3.99982 8.95455 3.57597C7.77722 3.15211 7.14923 4.57193 7.97945 6.09586ZM7.97945 6.09586C8.08468 6.71115 8.08899 6.70618 8.15772 7.10943C8.22778 7.52049 8.22428 7.5653 8.33318 8.17999M6.26922 7.43694C6.87557 7.65332 7.31484 7.81337 7.31484 7.81337C7.31484 7.81337 7.72812 7.96025 8.33318 8.17999M6.26922 7.43694C4.83359 6.34459 3.31108 6.68697 3.51918 7.88235C3.72729 9.07774 5.31607 8.8924 6.26922 7.43694ZM8.33318 8.17999C10.1597 8.26208 11.0773 9.48294 10.1081 10.2545C9.13889 11.026 8.06455 9.8819 8.33318 8.17999Z",
                  stroke: "#E30000",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "pencil"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "play"
        ? _c(
            "svg",
            {
              attrs: {
                width: "62",
                height: "62",
                viewBox: "0 0 62 62",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M61 31C61 47.5685 47.5685 61 31 61C14.4315 61 1 47.5685 1 31C1 14.4315 14.4315 1 31 1C47.5685 1 61 14.4315 61 31Z",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M21 47V15L49 30.4667L21 47Z",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "print"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M4 5V1H10.0625V5M3.4 11H2.2C1.88174 11 1.57652 10.8595 1.35147 10.6095C1.12643 10.3594 1 10.0203 1 9.66667V6.33333C1 5.97971 1.12643 5.64057 1.35147 5.39052C1.57652 5.14048 1.88174 5 2.2 5H11.8C12.1183 5 12.4235 5.14048 12.6485 5.39052C12.8736 5.64057 13 5.97971 13 6.33333V9.66667C13 10.0203 12.8736 10.3594 12.6485 10.6095C12.4235 10.8595 12.1183 11 11.8 11H10.6M4 9H10V13H4V9Z",
                  stroke: "#8E9CBB",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "settings"
        ? _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M8 9.90909C9.05436 9.90909 9.90909 9.05436 9.90909 8C9.90909 6.94564 9.05436 6.09091 8 6.09091C6.94564 6.09091 6.09091 6.94564 6.09091 8C6.09091 9.05436 6.94564 9.90909 8 9.90909Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M12.7091 9.90909C12.6244 10.101 12.5991 10.3139 12.6365 10.5204C12.674 10.7268 12.7724 10.9173 12.9191 11.0673L12.9573 11.1055C13.0756 11.2237 13.1695 11.364 13.2335 11.5185C13.2976 11.673 13.3305 11.8387 13.3305 12.0059C13.3305 12.1732 13.2976 12.3388 13.2335 12.4933C13.1695 12.6478 13.0756 12.7882 12.9573 12.9064C12.8391 13.0247 12.6987 13.1186 12.5442 13.1826C12.3897 13.2467 12.2241 13.2796 12.0568 13.2796C11.8896 13.2796 11.7239 13.2467 11.5694 13.1826C11.4149 13.1186 11.2746 13.0247 11.1564 12.9064L11.1182 12.8682C10.9682 12.7215 10.7777 12.6231 10.5713 12.5856C10.3649 12.5482 10.1519 12.5735 9.96 12.6582C9.77178 12.7388 9.61126 12.8728 9.4982 13.0435C9.38513 13.2143 9.32445 13.4143 9.32364 13.6191V13.7273C9.32364 14.0648 9.18955 14.3885 8.95086 14.6272C8.71218 14.8659 8.38846 15 8.05091 15C7.71336 15 7.38964 14.8659 7.15096 14.6272C6.91227 14.3885 6.77818 14.0648 6.77818 13.7273V13.67C6.77325 13.4594 6.70508 13.2551 6.58251 13.0837C6.45994 12.9123 6.28865 12.7818 6.09091 12.7091C5.89897 12.6244 5.68606 12.5991 5.47963 12.6365C5.27319 12.674 5.0827 12.7724 4.93273 12.9191L4.89455 12.9573C4.77634 13.0756 4.63598 13.1695 4.48147 13.2335C4.32696 13.2976 4.16135 13.3305 3.99409 13.3305C3.82683 13.3305 3.66122 13.2976 3.50671 13.2335C3.35221 13.1695 3.21184 13.0756 3.09364 12.9573C2.9753 12.8391 2.88143 12.6987 2.81738 12.5442C2.75333 12.3897 2.72036 12.2241 2.72036 12.0568C2.72036 11.8896 2.75333 11.7239 2.81738 11.5694C2.88143 11.4149 2.9753 11.2746 3.09364 11.1564L3.13182 11.1182C3.27852 10.9682 3.37694 10.7777 3.41437 10.5713C3.4518 10.3649 3.42653 10.1519 3.34182 9.96C3.26115 9.77178 3.12721 9.61126 2.95648 9.4982C2.78575 9.38513 2.58568 9.32445 2.38091 9.32364H2.27273C1.93518 9.32364 1.61146 9.18955 1.37277 8.95086C1.13409 8.71218 1 8.38846 1 8.05091C1 7.71336 1.13409 7.38964 1.37277 7.15096C1.61146 6.91227 1.93518 6.77818 2.27273 6.77818H2.33C2.54063 6.77325 2.74491 6.70508 2.91628 6.58251C3.08765 6.45994 3.21818 6.28865 3.29091 6.09091C3.37562 5.89897 3.40089 5.68606 3.36346 5.47963C3.32603 5.27319 3.22761 5.0827 3.08091 4.93273L3.04273 4.89455C2.92439 4.77634 2.83052 4.63598 2.76647 4.48147C2.70242 4.32696 2.66945 4.16135 2.66945 3.99409C2.66945 3.82683 2.70242 3.66122 2.76647 3.50671C2.83052 3.35221 2.92439 3.21184 3.04273 3.09364C3.16093 2.9753 3.3013 2.88143 3.4558 2.81738C3.61031 2.75333 3.77593 2.72036 3.94318 2.72036C4.11044 2.72036 4.27605 2.75333 4.43056 2.81738C4.58507 2.88143 4.72543 2.9753 4.84364 3.09364L4.88182 3.13182C5.0318 3.27852 5.22228 3.37694 5.42872 3.41437C5.63515 3.4518 5.84806 3.42653 6.04 3.34182H6.09091C6.27913 3.26115 6.43965 3.12721 6.55271 2.95648C6.66578 2.78575 6.72646 2.58568 6.72727 2.38091V2.27273C6.72727 1.93518 6.86136 1.61146 7.10005 1.37277C7.33873 1.13409 7.66245 1 8 1C8.33755 1 8.66127 1.13409 8.89995 1.37277C9.13864 1.61146 9.27273 1.93518 9.27273 2.27273V2.33C9.27354 2.53477 9.33422 2.73484 9.44729 2.90557C9.56035 3.0763 9.72087 3.21024 9.90909 3.29091C10.101 3.37562 10.3139 3.40089 10.5204 3.36346C10.7268 3.32603 10.9173 3.22761 11.0673 3.08091L11.1055 3.04273C11.2237 2.92439 11.364 2.83052 11.5185 2.76647C11.673 2.70242 11.8387 2.66945 12.0059 2.66945C12.1732 2.66945 12.3388 2.70242 12.4933 2.76647C12.6478 2.83052 12.7882 2.92439 12.9064 3.04273C13.0247 3.16093 13.1186 3.3013 13.1826 3.4558C13.2467 3.61031 13.2796 3.77593 13.2796 3.94318C13.2796 4.11044 13.2467 4.27605 13.1826 4.43056C13.1186 4.58507 13.0247 4.72543 12.9064 4.84364L12.8682 4.88182C12.7215 5.0318 12.6231 5.22228 12.5856 5.42872C12.5482 5.63515 12.5735 5.84806 12.6582 6.04V6.09091C12.7388 6.27913 12.8728 6.43965 13.0435 6.55271C13.2143 6.66578 13.4143 6.72646 13.6191 6.72727H13.7273C14.0648 6.72727 14.3885 6.86136 14.6272 7.10005C14.8659 7.33873 15 7.66245 15 8C15 8.33755 14.8659 8.66127 14.6272 8.89995C14.3885 9.13864 14.0648 9.27273 13.7273 9.27273H13.67C13.4652 9.27354 13.2652 9.33422 13.0944 9.44729C12.9237 9.56035 12.7898 9.72087 12.7091 9.90909Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "submit"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M13 7H3.22222M13 7L1 13L3.22222 7M13 7L1 1L3.22222 7",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "times"
        ? _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 12 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "times-bold"
        ? _c(
            "svg",
            {
              attrs: {
                width: "8",
                height: "8",
                viewBox: "0 0 8 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7.60446 7.53767C7.21544 7.9267 6.58272 7.92472 6.19126 7.53325L0.537119 1.88051C0.145652 1.48904 0.143673 0.856327 0.532697 0.467303C0.921721 0.078279 1.55443 0.0802596 1.9459 0.471726L7.60004 6.12447C7.99151 6.51594 7.99348 7.14865 7.60446 7.53767Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M7.61267 0.470534C7.2212 0.0790673 6.58849 0.0770864 6.19947 0.466111L0.537184 6.1284C0.14816 6.51743 0.150141 7.15014 0.541608 7.54161C0.933074 7.93307 1.56579 7.93505 1.95481 7.54603L7.61709 1.88374C8.00612 1.49471 8.00414 0.862001 7.61267 0.470534Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "upload"
        ? _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L4.70711 6.29289ZM7 10L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L7 10ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L10.7071 7.70711ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10H14ZM2 10C2 9.44771 1.55228 9 1 9C0.447715 9 0 9.44771 0 10H2ZM3.29289 7.70711L6.29289 10.7071L7.70711 9.29289L4.70711 6.29289L3.29289 7.70711ZM7.70711 10.7071L10.7071 7.70711L9.29289 6.29289L6.29289 9.29289L7.70711 10.7071ZM8 10V1H6V10H8ZM12 10V12H14V10H12ZM12 12H2V14H12V12ZM2 12V10H0V12H2ZM2 12H2H0C0 13.1046 0.895431 14 2 14V12ZM12 12V14C13.1046 14 14 13.1046 14 12H12Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "upload-light"
        ? _c(
            "svg",
            {
              attrs: {
                width: "26",
                height: "26",
                viewBox: "0 0 26 26",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7.70711 12.2929C7.31658 11.9024 6.68342 11.9024 6.29289 12.2929C5.90237 12.6834 5.90237 13.3166 6.29289 13.7071L7.70711 12.2929ZM13 19L12.2929 19.7071C12.6834 20.0976 13.3166 20.0976 13.7071 19.7071L13 19ZM19.7071 13.7071C20.0976 13.3166 20.0976 12.6834 19.7071 12.2929C19.3166 11.9024 18.6834 11.9024 18.2929 12.2929L19.7071 13.7071ZM14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM26 19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19H26ZM2 19C2 18.4477 1.55228 18 1 18C0.447715 18 0 18.4477 0 19H2ZM6.29289 13.7071L12.2929 19.7071L13.7071 18.2929L7.70711 12.2929L6.29289 13.7071ZM13.7071 19.7071L19.7071 13.7071L18.2929 12.2929L12.2929 18.2929L13.7071 19.7071ZM14 19V1H12V19H14ZM24 19V23H26V19H24ZM23 24H3V26H23V24ZM2 23V19H0V23H2ZM3 24C2.44772 24 2 23.5523 2 23H0C0 24.6569 1.34315 26 3 26V24ZM24 23C24 23.5523 23.5523 24 23 24V26C24.6569 26 26 24.6569 26 23H24Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "user"
        ? _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "18",
                viewBox: "0 0 16 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M13.9902 16.0625C13.9902 16.6148 14.4379 17.0625 14.9902 17.0625C15.5425 17.0625 15.9902 16.6148 15.9902 16.0625H13.9902ZM11.2513 10.9863V9.98628V10.9863ZM4.73896 10.9863V9.98628V10.9863ZM1 14.9745H0H1ZM0 16.0625C0 16.6148 0.447715 17.0625 1 17.0625C1.55228 17.0625 2 16.6148 2 16.0625H0ZM15.9902 16.0625V14.9745H13.9902V16.0625H15.9902ZM15.9902 14.9745C15.9902 13.6716 15.5056 12.4102 14.6246 11.4705L13.1656 12.8383C13.687 13.3945 13.9902 14.1619 13.9902 14.9745H15.9902ZM14.6246 11.4705C13.7416 10.5286 12.5297 9.98628 11.2513 9.98628V11.9863C11.9561 11.9863 12.6462 12.2843 13.1656 12.8383L14.6246 11.4705ZM11.2513 9.98628H4.73896V11.9863H11.2513V9.98628ZM4.73896 9.98628C3.46052 9.98628 2.24859 10.5286 1.36558 11.4705L2.82465 12.8383C3.34403 12.2843 4.03413 11.9863 4.73896 11.9863V9.98628ZM1.36558 11.4705C0.484619 12.4102 0 13.6716 0 14.9745H2C2 14.1619 2.30323 13.3945 2.82465 12.8383L1.36558 11.4705ZM0 14.9745V16.0625H2V14.9745H0ZM9.95503 3.99117C9.95503 5.09086 9.06355 5.98234 7.96386 5.98234V7.98234C10.1681 7.98234 11.955 6.19543 11.955 3.99117H9.95503ZM7.96386 5.98234C6.86417 5.98234 5.97269 5.09086 5.97269 3.99117H3.97269C3.97269 6.19543 5.7596 7.98234 7.96386 7.98234V5.98234ZM5.97269 3.99117C5.97269 2.89148 6.86417 2 7.96386 2V0C5.7596 0 3.97269 1.78691 3.97269 3.99117H5.97269ZM7.96386 2C9.06355 2 9.95503 2.89148 9.95503 3.99117H11.955C11.955 1.78691 10.1681 0 7.96386 0V2Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "user-transfer"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 17",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 12a1 1 0 1 0 0 2v-2Zm7 1 .7.713.727-.713-.726-.713L8 13ZM6.155 9.787a1 1 0 0 0-1.401 1.426l1.401-1.426Zm-1.401 5a1 1 0 1 0 1.401 1.426l-1.401-1.426Zm9.236 1.275a1 1 0 1 0 2 0h-2Zm-2.739-5.076v-1 1Zm-.751-1a1 1 0 0 0 0 2v-2ZM1 14h7v-2H1v2Zm7.7-1.713-2.545-2.5-1.401 1.426 2.545 2.5 1.402-1.426Zm-1.4 0-2.546 2.5 1.401 1.426 2.546-2.5-1.402-1.426Zm8.69 3.775v-1.088h-2v1.088h2Zm0-1.088a5.127 5.127 0 0 0-1.365-3.504l-1.46 1.368c.522.557.825 1.324.825 2.137h2Zm-1.365-3.504a4.624 4.624 0 0 0-3.374-1.484v2c.705 0 1.395.298 1.915.852l1.459-1.367ZM11.25 9.986h-.75v2h.751v-2ZM9.955 3.991a1.99 1.99 0 0 1-1.991 1.991v2a3.991 3.991 0 0 0 3.991-3.99h-2ZM7.964 5.982a1.99 1.99 0 0 1-1.991-1.99h-2a3.991 3.991 0 0 0 3.99 3.99v-2Zm-1.991-1.99c0-1.1.891-1.992 1.99-1.992V0a3.991 3.991 0 0 0-3.99 3.991h2ZM7.963 2c1.1 0 1.992.891 1.992 1.991h2A3.991 3.991 0 0 0 7.964 0v2Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "word"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.8638 3.936L9.95481 10.2H7.54281L6.98481 5.70001L6.36381 10.2H4.00581L3.13281 3.936H4.98681L5.38281 8.859L6.04881 3.936H7.98381L8.54181 8.859L9.08181 3.936H10.8638Z",
                  fill: "#2E6ECD",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M1 13V1H13V13H1Z",
                  stroke: "#2E6ECD",
                  "stroke-width": "2",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "warning"
        ? _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "10",
                  cy: "10",
                  r: "9",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              }),
              _c("circle", {
                attrs: { cx: "10", cy: "14", r: "1", fill: "currentColor" },
              }),
              _c("rect", {
                attrs: {
                  x: "9",
                  y: "5",
                  width: "2",
                  height: "6",
                  rx: "1",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "place"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "18",
                viewBox: "0 0 14 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M13 7.66501C13 12.3317 7 16.3317 7 16.3317C7 16.3317 1 12.3317 1 7.66501C1 6.07371 1.63214 4.54759 2.75736 3.42237C3.88258 2.29715 5.4087 1.66501 7 1.66501C8.5913 1.66501 10.1174 2.29715 11.2426 3.42237C12.3679 4.54759 13 6.07371 13 7.66501Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M7 9.66501C8.10457 9.66501 9 8.76958 9 7.66501C9 6.56044 8.10457 5.66501 7 5.66501C5.89543 5.66501 5 6.56044 5 7.66501C5 8.76958 5.89543 9.66501 7 9.66501Z",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "ls"
        ? _c(
            "svg",
            {
              attrs: {
                width: "12",
                height: "10",
                viewBox: "0 0 12 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7H12ZM10 3C10 3.55228 10.4477 4 11 4C11.5523 4 12 3.55228 12 3H10ZM0.0298575 8.75746C-0.104091 9.29326 0.221669 9.83619 0.757464 9.97014C1.29326 10.1041 1.83619 9.77833 1.97014 9.24254L0.0298575 8.75746ZM3 1L3.97014 0.757464C3.85885 0.312297 3.45887 0 3 0C2.54113 0 2.14115 0.312297 2.02986 0.757464L3 1ZM4.02986 9.24254C4.16381 9.77833 4.70674 10.1041 5.24254 9.97014C5.77833 9.83619 6.10409 9.29326 5.97014 8.75746L4.02986 9.24254ZM8 7V3H6V7H8ZM9 8C8.44772 8 8 7.55228 8 7H6C6 8.65685 7.34315 10 9 10V8ZM10 7C10 7.55228 9.55228 8 9 8V10C10.6569 10 12 8.65685 12 7H10ZM9 2C9.55228 2 10 2.44772 10 3H12C12 1.34315 10.6569 0 9 0V2ZM9 0C7.34315 0 6 1.34315 6 3H8C8 2.44772 8.44772 2 9 2V0ZM1.97014 9.24254L3.97014 1.24254L2.02986 0.757464L0.0298575 8.75746L1.97014 9.24254ZM2.02986 1.24254L4.02986 9.24254L5.97014 8.75746L3.97014 0.757464L2.02986 1.24254Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "close"
        ? _c(
            "svg",
            {
              attrs: {
                width: "12",
                height: "13",
                viewBox: "0 0 12 13",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.291861 11.761C0.681008 12.1491 1.31194 12.1491 1.70109 11.761L11.7081 1.78085C12.0973 1.39281 12.0973 0.763658 11.7081 0.37561C11.319 -0.0124369 10.6881 -0.0124369 10.2989 0.37561L0.291861 10.3558C-0.0972872 10.7438 -0.0972872 11.373 0.291861 11.761Z",
                  fill: "currentColor",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M0.354112 0.291007C0.743259 -0.0970402 1.37419 -0.0970402 1.76334 0.291007L11.7081 10.2105C12.0973 10.5986 12.0973 11.2277 11.7081 11.6158C11.319 12.0038 10.6881 12.0038 10.2989 11.6158L0.354112 1.69625C-0.0350361 1.3082 -0.0350361 0.679054 0.354112 0.291007Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "pass"
        ? _c(
            "svg",
            {
              attrs: {
                width: "18",
                height: "17",
                viewBox: "0 0 18 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "4",
                  y: "7.5",
                  width: "4",
                  height: "5",
                  rx: "1",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M9 5.5V1.5M13 8.5H11M13 11.5H11M3 15.5H15C16.1046 15.5 17 14.6046 17 13.5V5.5C17 4.39543 16.1046 3.5 15 3.5H3C1.89543 3.5 1 4.39543 1 5.5V13.5C1 14.6046 1.89543 15.5 3 15.5Z",
                  stroke: "#8E9CBB",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "clock"
        ? _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7 4.5V7.5L9 8.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z",
                  stroke: "#8E9CBB",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "man"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "17",
                viewBox: "0 0 16 17",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M15 16V14.9165C15 13.8632 14.6058 12.853 13.9041 12.1081C13.2024 11.3633 12.2508 10.9448 11.2584 10.9448H4.74157C3.74925 10.9448 2.79756 11.3633 2.09588 12.1081C1.3942 12.853 1 13.8632 1 14.9165V16M10.962 3.97876C10.962 5.62388 9.62186 6.95752 7.96873 6.95752C6.3156 6.95752 4.97547 5.62388 4.97547 3.97876C4.97547 2.33364 6.3156 1 7.96873 1C9.62186 1 10.962 2.33364 10.962 3.97876Z",
                  stroke: "#8E9CBB",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "vacancy"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "12",
                height: "14",
                viewBox: "0 0 12 14",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M2 8.5H10M8 9.5V8.5M4 9.5V8.5M4 3.5C4 2.39543 4.89543 1.5 6 1.5C7.10457 1.5 8 2.39543 8 3.5M2.48148 4.5H9.51852C10.3367 4.5 11 5.21634 11 6.1V10.9C11 11.7837 10.3367 12.5 9.51852 12.5H2.48148C1.66328 12.5 1 11.7837 1 10.9V6.1C1 5.21634 1.66328 4.5 2.48148 4.5Z",
                  stroke: "#FF238D",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "status-new"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7 2V8.5M10.4253 3.07318C11.9816 4.15718 13 5.95965 13 8C13 11.3137 10.3137 14 7 14C3.68629 14 1 11.3137 1 8C1 5.95965 2.01843 4.15718 3.57468 3.07318",
                  stroke: "#0066FF",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "status-in-progress"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7 4.5V7.5L9 8.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z",
                  stroke: "#FFB800",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "status-well-performing"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 6.5L7 8.5C7 8.5 10.3284 5.17157 11.5 4M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z",
                  stroke: "#12C971",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "status-partially-performing"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 7.5H9M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z",
                  stroke: "#8E9CBB",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "status-not-performing"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "15",
                viewBox: "0 0 14 15",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 5.5L9 9.5M9 5.5L5 9.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z",
                  stroke: "#FF238D",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "notifications"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M2.99995 5.4C2.99995 2.774 4.97198 0 7.99995 0C11.0283 0 12.9999 2.77378 12.9999 5.4C12.9999 7.83407 13.4733 9.32855 13.8959 10.1806C14.1079 10.6083 14.3111 10.8823 14.4452 11.038C14.5125 11.1162 14.5631 11.1654 14.5898 11.1898C14.5994 11.1986 14.6059 11.2042 14.609 11.2069C14.9449 11.4647 15.0826 11.9072 14.9503 12.3112C14.8157 12.7221 14.4323 13 13.9999 13H9.17204C9.33646 13.003 9.50244 13.0467 9.65477 13.135C10.1325 13.4122 10.2951 14.0241 10.0179 14.5018C9.81282 14.8553 9.51846 15.1488 9.16431 15.3527C8.81016 15.5567 8.40864 15.6641 7.99995 15.6641C7.59125 15.6641 7.18973 15.5567 6.83558 15.3527C6.48143 15.1488 6.18707 14.8553 5.98198 14.5018C5.70483 14.0241 5.86741 13.4122 6.34512 13.135C6.49745 13.0467 6.66343 13.003 6.82785 13H1.99995C1.56755 13 1.18414 12.7221 1.04959 12.3112C0.917331 11.9072 1.055 11.4647 1.39089 11.2069C1.39402 11.2042 1.40054 11.1986 1.4101 11.1898C1.43677 11.1654 1.4874 11.1162 1.55469 11.038C1.68877 10.8823 1.89198 10.6083 2.10403 10.1806C2.52654 9.32855 2.99995 7.83407 2.99995 5.4ZM3.9297 11H12.0702C11.5061 9.83345 10.9999 8.04611 10.9999 5.4C10.9999 3.5852 9.65177 2 7.99995 2C6.34845 2 4.99995 3.58548 4.99995 5.4C4.99995 8.04611 4.49376 9.83345 3.9297 11ZM6.86418 13C7.20261 13.0062 7.52965 13.184 7.71191 13.4982C7.74119 13.5486 7.7832 13.5905 7.83375 13.6196C7.8843 13.6487 7.94161 13.6641 7.99995 13.6641C8.05828 13.6641 8.11559 13.6487 8.16614 13.6196C8.21669 13.5905 8.2587 13.5486 8.28798 13.4982C8.47024 13.184 8.79728 13.0062 9.13571 13H6.86418Z",
                  fill: "#333333",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "logout"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M3.33331 2.66683C3.1565 2.66683 2.98693 2.73707 2.86191 2.86209C2.73688 2.98712 2.66665 3.15668 2.66665 3.3335V12.6668C2.66665 12.8436 2.73688 13.0132 2.86191 13.1382C2.98693 13.2633 3.1565 13.3335 3.33331 13.3335H5.99998C6.36817 13.3335 6.66665 13.632 6.66665 14.0002C6.66665 14.3684 6.36817 14.6668 5.99998 14.6668H3.33331C2.80288 14.6668 2.29417 14.4561 1.9191 14.081C1.54403 13.706 1.33331 13.1973 1.33331 12.6668V3.3335C1.33331 2.80306 1.54403 2.29436 1.9191 1.91928C2.29417 1.54421 2.80288 1.3335 3.33331 1.3335H5.99998C6.36817 1.3335 6.66665 1.63197 6.66665 2.00016C6.66665 2.36835 6.36817 2.66683 5.99998 2.66683H3.33331ZM10.1952 4.19543C10.4556 3.93508 10.8777 3.93508 11.1381 4.19543L14.4714 7.52876C14.7317 7.78911 14.7317 8.21122 14.4714 8.47157L11.1381 11.8049C10.8777 12.0653 10.4556 12.0653 10.1952 11.8049C9.93489 11.5446 9.93489 11.1224 10.1952 10.8621L12.3905 8.66683H5.99998C5.63179 8.66683 5.33331 8.36835 5.33331 8.00016C5.33331 7.63197 5.63179 7.3335 5.99998 7.3335H12.3905L10.1952 5.13823C9.93489 4.87788 9.93489 4.45577 10.1952 4.19543Z",
                  fill: "#3C4760",
                  "fill-opacity": "0.65",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.name === "collapse"
        ? _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "11",
                  cy: "11",
                  r: "10.5",
                  fill: "white",
                  stroke: "#D3D8DF",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                  fill: "#0066FF",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                  fill: "#0066FF",
                },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }